import React from 'react';
import CustomRadio from '@/common/CustomRadio';
import DropDown from '@/common/DropDown';
import ModalComponent from '@/common/Modal';
import {
  getDealerActionsToBeSaved,
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress
} from '@/explore/ducks/selectors';
import {
  callToCreateDealerAction,
  setDealerActionsToBeSaved,
  setDealerOptOutValue,
  setIsBlackListed,
  setIsCreateDealerActionCompleted,
  setIsCreateDealerActionInprogress,
  setIsDealerOptOut,
  setOptinOptoutEdited,
  setTransferFeeStatus
} from '@/explore/ducks/slice';
import {
  EditValuesToBeSavedInterface,
  FeesInterface
} from '@/model/editDetails.mjs';
import { getIsGlobalAdmin, getIsStoreAdmin } from '@/redux/app-selectors';
import { jusThisStoreValues, allStoreValues } from '@/utils/constants';
import {
  Button,
  InputGroup,
  InputLeftAddon,
  NumberInput,
  NumberInputField,
  Image,
  useDisclosure,
  Radio,
  RadioGroup,
  Switch
} from '@chakra-ui/react';
import { isNull, isString } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateBlacklistedStatus } from '@/api/apis';

function EditTransferFee({
  onClose,
  isOpen,
  transferFees,
  isBlacklisted,
  licenseKey,
  optOutOptions
}: {
  onClose(): void;
  isOpen: boolean;
  transferFees: FeesInterface;
  isBlacklisted: boolean;
  licenseKey: string;
  optOutOptions: string;
}) {
  const initialValues = {
    nics_fee: null,
    discount_multiple_firearms: null,
    suppressor_fee: null,
    pistol_fee: null,
    rifle_fee: null,
    sbr_fee: null,
    pistol_enabled: false,
    rifle_enabled: false,
    sbr_enabled: false,
  };
  const [editValues, setEditValues] = useState<FeesInterface>(initialValues);
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const [isBlacklist, setIsBlacklist] = useState(isBlacklisted)
  const [isChange, setIsChange] = useState(false)
  const [optinOptout, setOptinOptout] = useState('');
  const [optOutOptionFor, setOptOutOptionFor] = useState(
    Object.keys(allStoreValues).includes(optOutOptions)
      ? 'all_store'
      : Object.keys(jusThisStoreValues).includes(optOutOptions)
        ? 'just_this_store'
        : ''
  );
  const [justThisStoreOption, setJustThisStoreOption] = useState(
    optOutOptions === 'store' ? 'optout' : 'optin'
  );
  const [allStoreOption, setAllStoreOption] = useState(
    optOutOptions === 'all' ? 'optout' : 'optin'
  );
  const dispatch = useDispatch();
  const {
    isOpen: isOptinOptoutDropDownActive,
    onClose: onCloseOptinOptoutDropdown,
    onOpen: onOpenOptinOptoutDropdown
  } = useDisclosure();
  const isGlobalAdmin = getIsGlobalAdmin();
  const isStoreAdmin = getIsStoreAdmin();

  useEffect(() => {
    return () => {
      dispatch(setDealerActionsToBeSaved([]));
    };
  }, []);

  useEffect(() => {
    if (isCreateDealerActionCompleted) {
      dispatch(setTransferFeeStatus(editValues));
      dispatch(setIsCreateDealerActionCompleted(false));
      if (optinOptout) {
        dispatch(setOptinOptoutEdited(optinOptout));
        dispatch(setDealerOptOutValue(optinOptout));
        dispatch(setIsDealerOptOut(optinOptout === 'all' || optinOptout === 'store'));
      }
      onClose();
    }
  }, [isCreateDealerActionCompleted]);

  useEffect(() => {
    setEditValues({
      nics_fee: transferFees?.nics_fee,
      discount_multiple_firearms: transferFees?.discount_multiple_firearms,
      suppressor_fee: transferFees?.suppressor_fee,
      pistol_fee: transferFees?.pistol_fee,
      rifle_fee: transferFees?.rifle_fee,
      sbr_fee: transferFees?.sbr_fee,
      pistol_enabled: transferFees?.pistol_enabled,
      rifle_enabled: transferFees?.rifle_enabled,
      sbr_enabled: transferFees?.sbr_enabled,
    });
  }, [transferFees]);

  function onChangeHandler(
    fielddName: string,
    value: boolean | string,
    type: string
  ) {
    if (isString(value) && value.length > 5) {
      return;
    }
    if (fielddName === "isBlacklisted") {
      setIsBlacklist(value as boolean)
      setIsChange(true)
    } else {
      setEditValues({ ...editValues, [fielddName]: value });
      type transferTransferFeesKeyType = keyof typeof transferFees;
      if (
        (type === 'status' &&
          transferFees[fielddName as transferTransferFeesKeyType] !== value) ||
        (type === 'fee' &&
          transferFees &&
          transferFees[fielddName as transferTransferFeesKeyType] !==
          Number(value))
      )
        updateDealerAction({
          value,
          name: fielddName,
          license_key: licenseKey,
          type: 'add'
        });
      else {
        updateDealerAction(
          { value, name: fielddName, license_key: licenseKey, type: 'add' },
          true
        );
      }
    }
  }
  const updateDealerAction = (
    editParams: EditValuesToBeSavedInterface,
    isAlreadyExist?: boolean
  ) => {
    if (isAlreadyExist) {
      const actions = dealerActionsToBeSaved.filter(
        (action) => action.name != editParams.name
      );
      dispatch(setDealerActionsToBeSaved(actions));
      return;
    }
    let recordExist = false;
    const actions = dealerActionsToBeSaved.map((action) => {
      if (action.name === editParams.name) {
        recordExist = true;
        return editParams;
      }
      return action;
    });
    if (recordExist) dispatch(setDealerActionsToBeSaved(actions));
    else
      dispatch(
        setDealerActionsToBeSaved([...dealerActionsToBeSaved, editParams])
      );
  };

  const onSaveHandler = async () => {
    await dispatch(setIsCreateDealerActionInprogress(true))
    if (isBlacklist !== null && isStoreAdmin) {
      const isblacklisted = await updateBlacklistedStatus({ data: { isBlacklisted: isBlacklist }, licenseKey })
      if (isblacklisted.status == 200) {
        dispatch(setIsBlackListed(isblacklisted.data.isBlacklisted))
      }
    }
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved }));
    setIsChange(false);
  };

  const updateFinalOptinOptoutValue = () => {
    let optiOptout = '';
    if (optOutOptionFor === 'just_this_store') {
      if (justThisStoreOption === 'optout') optiOptout = 'store';
      else if (justThisStoreOption === 'optin') optiOptout = 'opt_in_store';
    }
    if (optOutOptionFor === 'all_store') {
      if (allStoreOption === 'optin') optiOptout = 'opt_in_all';
      else if (allStoreOption === 'optout') optiOptout = 'all';
    }
    const params = {
      value: optiOptout,
      name: 'optin_optout_value',
      license_key: licenseKey,
      isBlacklisted: isBlacklist,
      type: 'add'
    };
    setOptinOptout(optiOptout);
    if (optiOptout && optiOptout != optOutOptions) {
      updateDealerAction(params);
    } else {
      updateDealerAction(params, true);
    }
  };

  const onChangeOptinOptoutFor = (value: string) => {
    setOptOutOptionFor(value);
  };

  const onChangeOptinOptoutJustThisStore = (event: any, type: string) => {
    if (type === 'just_this_store') {
      if (event.target.checked) setJustThisStoreOption('optin');
      else setJustThisStoreOption('optout');
    }
    if (type === 'all_store') {
      if (event.target.checked) setAllStoreOption('optin');
      else setAllStoreOption('optout');
    }
  };

  useEffect(() => {
    updateFinalOptinOptoutValue();
  }, [optOutOptionFor, justThisStoreOption, allStoreOption]);

  return (
    <ModalComponent
      onClose={onClose}
      isOpen={isOpen}
      title={<>Transfer Details and Other Services</>}
      variant={2}
      className='transfer-fee-modal'
      footer={
        <>
          <Button
            colorScheme="blue"
            onClick={onClose}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            marginRight="20px"
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isDisabled={dealerActionsToBeSaved.length <= 0 && !isChange}
            isLoading={isCreateDealerActionInprogress}
          >
            Save
          </Button>
        </>
      }
      maxWidth="856px"
    >
      <div className="transfer-fees-edit">
        <div className="transfer-fees-edit__left">
          <ul className="transfer-fees-edit__rows">
            <li className="transfer-fees-edit__row">
              <label
                htmlFor="pistol_enabled"
                className="transfer-fees-edit__label"
              >
                <div className="transfer-fees-edit__checkbox-wrapper">
                  <input
                    type="checkbox"
                    className="transfer-fees-edit__checkbox"
                    onChange={(event) =>
                      onChangeHandler(
                        'pistol_enabled',
                        event.target.checked,
                        'status'
                      )
                    }
                    id="pistol_enabled"
                    checked={editValues.pistol_enabled}
                  />
                  <Image src="/images/ui/checked.svg" />
                </div>
                Handgun
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  value={editValues.pistol_fee || ''}
                >
                  <NumberInputField
                    placeholder="Enter Handgun Fee"
                    onChange={(event) =>
                      onChangeHandler('pistol_fee', event.target.value, 'fee')
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
            <li className="transfer-fees-edit__row">
              <label
                htmlFor="rifle_enabled"
                className="transfer-fees-edit__label"
              >
                <div className="transfer-fees-edit__checkbox-wrapper">
                  <input
                    type="checkbox"
                    className="transfer-fees-edit__checkbox"
                    id="rifle_enabled"
                    checked={editValues.rifle_enabled}
                    onChange={(event) =>
                      onChangeHandler(
                        'rifle_enabled',
                        event.target.checked,
                        'status'
                      )
                    }
                  />
                  <Image src="/images/ui/checked.svg" />
                </div>
                Long Gun
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  value={editValues.rifle_fee || ''}
                >
                  <NumberInputField
                    placeholder="Enter Long Gun Fee"
                    onChange={(event) =>
                      onChangeHandler('rifle_fee', event.target.value, 'fee')
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
            <li className="transfer-fees-edit__row">
              <label
                htmlFor="sbr_enabled"
                className="transfer-fees-edit__label"
              >
                <div className="transfer-fees-edit__checkbox-wrapper">
                  <input
                    type="checkbox"
                    className="transfer-fees-edit__checkbox"
                    id="sbr_enabled"
                    checked={editValues.sbr_enabled}
                    onChange={(event) =>
                      onChangeHandler(
                        'sbr_enabled',
                        event.target.checked,
                        'status'
                      )
                    }
                  />
                  <Image src="/images/ui/checked.svg" />
                </div>
                Other Firearms
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  className="transfer-fees-edit__input"
                  value={editValues.sbr_fee || ''}
                >
                  <NumberInputField
                    placeholder="Enter Other Fee"
                    onChange={(event) =>
                      onChangeHandler('sbr_fee', event.target.value, 'fee')
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
          </ul>
        </div>
        <div className="transfer-fees-edit__right">
          <ul className="transfer-fees-edit__rows">
            <li className="transfer-fees-edit__row">
              <label htmlFor="" className="transfer-fees-edit__label">
                Extra NICS Fee
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  padding={0}
                  value={editValues.nics_fee || ''}
                >
                  <NumberInputField
                    placeholder="Enter Extra NICS Fee"
                    onChange={(event) =>
                      onChangeHandler('nics_fee', event.target.value, 'fee')
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
            <li className="transfer-fees-edit__row">
              <label htmlFor="" className="transfer-fees-edit__label">
                Extra Firearm Fee
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  value={editValues.suppressor_fee || ''}
                >
                  <NumberInputField
                    placeholder="Enter Extra Firearm Fee"
                    onChange={(event) =>
                      onChangeHandler(
                        'suppressor_fee',
                        event.target.value,
                        'fee'
                      )
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
            <li className="transfer-fees-edit__row">
              <label htmlFor="" className="transfer-fees-edit__label">
                Discounts for multiple firearms
              </label>
              <InputGroup className="transfer-fees-edit__input">
                <InputLeftAddon
                  children="$"
                  className="transfer-fees-edit__currency-indicator"
                />
                <NumberInput
                  color={'black'}
                  className="transfer-fees-edit__input"
                  value={editValues?.discount_multiple_firearms || ""}
                >
                  <NumberInputField
                    placeholder="Enter Discount Amount"
                    onChange={(event) =>
                      onChangeHandler(
                        'discount_multiple_firearms',
                        event.target.value,
                        'fee'
                      )
                    }
                  />
                </NumberInput>
              </InputGroup>
            </li>
            <li className="transfer-fees-edit__row">
              <span className="transfer-fees-edit__label">
                Opt In & Opt Out:
              </span>
              <DropDown
                onClose={onCloseOptinOptoutDropdown}
                onOpen={onOpenOptinOptoutDropdown}
                isOpen={isOptinOptoutDropDownActive}
                placement="top-end"
                popoverContent={
                  <ul className="transfer-edit__optin-optout-for">
                    <li>
                      <div className='transfer-edit__optin-optout-radios'>
                        {/* <Radio
                            value="just_this_store"
                            name="optin-optout-for"
                            className="transfer-edit__optin-optout-label"
                            marginBottom={'10px'}
                          >
                            For this store
                          </Radio> */}
                        {!isGlobalAdmin && <label className='transfer-edit__optin-optout-label'>
                          <CustomRadio
                            name="optin-optout-for"
                            onChange={() => onChangeOptinOptoutFor("just_this_store")}
                            isChecked={optOutOptionFor === "just_this_store"}
                            value="just_this_store"
                            id="just_this_store"
                          />
                          For this store
                        </label>}
                        <label className='transfer-edit__optin-optout-label'>
                          <CustomRadio
                            name="optin-optout-for"
                            onChange={() => onChangeOptinOptoutFor("all_store")}
                            isChecked={optOutOptionFor === "all_store"}
                            value="all_store"
                            id="all_store"
                          />
                          For all stores
                        </label>
                      </div>
                      {/* </RadioGroup> */}
                    </li>
                    <li>
                      <div className="transfer-edit__optin-optout-switches">
                        {!isGlobalAdmin && <div className="transfer-edit__optin-optout-switch-wrap">
                          <Switch
                            size="md"
                            isChecked={justThisStoreOption === 'optin'}
                            onChange={(event) =>
                              onChangeOptinOptoutJustThisStore(
                                event,
                                'just_this_store'
                              )
                            }
                          />
                          <span className="transfer-edit__optin-optout-switch-label">
                            {justThisStoreOption === 'optout'
                              ? 'Optout'
                              : 'Optin'}
                          </span>
                        </div>}
                        <div className="transfer-edit__optin-optout-switch-wrap">
                          <Switch
                            size="md"
                            isChecked={allStoreOption === 'optin'}
                            onChange={(event) =>
                              onChangeOptinOptoutJustThisStore(
                                event,
                                'all_store'
                              )
                            }
                          />
                          <span className="transfer-edit__optin-optout-switch-label">
                            {allStoreOption === 'optout' ? 'Optout' : 'Optin'}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                }
                variant="optin-optout"
              >
                <button className="transfer-fees-edit__optin_optout">
                  <span className="transfer-fees-edit__selected">
                    {optOutOptionFor === 'just_this_store'
                      ? 'Just this store'
                      : optOutOptionFor === 'all_store'
                        ? 'All Store'
                        : ''}
                    {' - '}
                    {optOutOptionFor === 'just_this_store'
                      ? justThisStoreOption
                      : optOutOptionFor === 'all_store'
                        ? allStoreOption
                        : ''}
                  </span>
                  <Image
                    src="/images/ui/down-arrow.svg"
                    className="license_details_down_arrow"
                  />
                </button>
              </DropDown>
            </li>
            {isStoreAdmin && <li className="transfer-fees-edit__row">
              <span className="transfer-fees-edit__label">Blacklisted</span>
              <div className='transfer-fees-edit__input'>
                <Switch size="md" colorScheme="facebook" onChange={(event) =>
                  onChangeHandler(
                    'isBlacklisted',
                    event.target.checked,
                    'status'
                  )
                } isChecked={isBlacklist} />
              </div>
            </li>}
          </ul>
        </div>
      </div>
    </ModalComponent>
  );
}

export default EditTransferFee;
